import moment from 'moment';

const UserListColumn = [
  {
    title: 'No.',
    dataIndex: 'index',
    width: 80
  },
  {
    title: 'CID',
    dataIndex: 'customerId',
    width: 100
  },
  {
    title: 'OID',
    dataIndex: 'ownerId',
    width: 100
  },
  {
    title: 'User',
    dataIndex: 'userName',
    slot: 'userName',
    width: 250
  },
  {
    title: 'Created',
    dataIndex: 'createDate',
    slot: 'createDate',
    width: 150,
    sorter: (a, b) => moment(a.createDate).diff(moment(b.createDate)),
  },
  {
    title: 'Expired',
    dataIndex: 'expiryDate',
    slot: 'expiryDate',
    width: 150,
    sorter: (a, b) => moment(a.expiryDate).diff(moment(b.expiryDate)),
  },
  {
    title: 'SMS',
    dataIndex: 'smsBalance',
    width: 100
  },
  {
    title: 'Gold',
    dataIndex: 'gold',
    width: 100
  },
  {
    title: 'Silver',
    dataIndex: 'silver',
    width: 100
  },
  {
    title: 'Bronze',
    dataIndex: 'bronze',
    width: 100
  },
  {
    title: 'Trial',
    dataIndex: 'trial',
    width: 100
  },
  {
    title: 'Status',
    dataIndex: 'status',
    slot: 'status',
    width: 150,
    sorter: (a, b) => (a.status || '').localeCompare(b.status || '')
  },
  {
    title: '',
    dataIndex: '',
    width: 50,
    slot: 'operation'
  }
];

export { UserListColumn };
